import axios from '../../utils/axios';
import CRUD from './crud'

const coachDiscounts = new CRUD('coach-discounts', 'superior-judge')

export default Object.assign(
    coachDiscounts,
    {
        reducers: {
            ...coachDiscounts.reducers
        },

    }
)
